import { useEffect, useRef } from "react";
import { useHits, useInstantSearch } from "react-instantsearch";
import { useProductsViewedEvent } from "@hooks/use-analytics-events";

function CatalogProductsViewed({ appliedHubOrListingPageSlug }) {
  const { status, uiState, results } = useInstantSearch();
  const { items } = useHits();
  const productsViewedEvent = useProductsViewedEvent();

  const isMounted = useRef(false);
  const lastProductsUidsSent = useRef([]);

  useEffect(() => {
    function sendProductsViewedEvent() {
      if (!isMounted.current) {
        isMounted.current = true;
        return;
      }

      const productsUids = items.map((item) => item.objectID);

      const isEventAlreadySent =
        productsUids.length === lastProductsUidsSent.current.length &&
        productsUids.every((value, index) => value === lastProductsUidsSent.current[index]);
      if (isEventAlreadySent || status !== "idle") return;

      lastProductsUidsSent.current = productsUids;
      const source = "catalog";
      const hubOrListingPageSlug = appliedHubOrListingPageSlug.current;
      const abTest = {
        id: results?.abTestID,
        variant_id: results?.abTestVariantID,
      };

      productsViewedEvent(source, hubOrListingPageSlug, productsUids, uiState, abTest);
    }

    sendProductsViewedEvent();
  }, [appliedHubOrListingPageSlug, items, productsViewedEvent, status, uiState]);

  return null;
}

export default CatalogProductsViewed;
